import { Component, OnInit } from '@angular/core';
import { DraftManagerService } from '../draft-manager.service';
import { DraftSelectService } from '../draft-select.service';

@Component({
  selector: 'app-draft-window',
  templateUrl: './draft-window.component.html',
  styleUrls: ['./draft-window.component.scss']
})
export class DraftWindowComponent implements OnInit {

  constructor(
    private draftManagerService: DraftManagerService,
    private draftSelectService: DraftSelectService,
  ) { }

  ngOnInit() {
  }

  lockSelection() {
    let champion = this.draftSelectService.selectionSource["_value"][1].id;
    this.draftManagerService.setDraft(this.draftManagerService.phase['type'], this.draftManagerService.phase['id'], champion);
    this.draftManagerService.nextPhase();
  }

}
